import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import useStore from "../../state-files/zustondStoreStates";
import HeaderItems from "../HeaderItems";
import HeaderProfileSettings from "../HeaderProfileSettings";
import { IconButton } from '@mui/material';
import { Avatar, Badge } from '@mui/material';
import { useMediaQuery } from "@mui/system";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import fetchAdminReports from "../../helper-methods/fetchAdminReports";

const HeaderBar = ({ isLoggedIn }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const { data: userData } = useQuery({ queryKey: ['user'] });
  const setDiscussions = useStore((state) => state.setDiscussions);
  const { setCurrentCommunityId, setCurrentCommunityName, mobileSidebarExpanded, setMobileSidebarExpanded } = useStore(); // Use zustand store
  const isMobile = useMediaQuery('(max-width:1300px)');
  const { setIsLoggedIn } = useStore();
  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const [isAdmin, setIsAdmin] = React.useState([]);
  const [reports, setReports] = React.useState([]);
  const [attempts, setAttempts] = React.useState(0);

  const login = async () => {
    if (attempts < 3 && localStorage.getItem('roles').length > 1) {
      setIsAdmin(await fetchAdminReports(setReports));
      setAttempts((prev) => prev + 1);
    } else {
      setIsAdmin(false);
    }
  }

  useEffect(() => {
    login();
  }, []);


  //Search related information
  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '1200%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'rgba(40, 165, 52, 0.5)', color: '#FFFFFF' }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ color: 'green', cursor: 'pointer', alignItems: 'center' }}>
          {isMobile ? (
            <Typography variant="h6" component="div" sx={{ display: 'flex', color: 'green', cursor: 'pointer', alignItems: 'center' }} onClick={() => {
              setMobileSidebarExpanded(!mobileSidebarExpanded);
            }}>
              <MenuIcon /> RW
            </Typography>
          ) : (
            <Typography variant="h1" component="div" sx={{ color: 'green', cursor: 'pointer', fontWeight: 'bold', fontSize: { xs: '1.1rem', md: '1.25rem' } }} >
              Rōpū Whakatau
            </Typography>
          )}
        </Typography>

        <Box sx={{ flexGrow: 0.5 }} />

        <HeaderItems
          anchorEl={anchorEl}
          handleCloseMenu={handleCloseMenu}
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          setCurrentCommunityId={setCurrentCommunityId}
          setCurrentCommunityName={setCurrentCommunityName}
          setDiscussions={setDiscussions}
          handleOpenMenu={handleOpenMenu}
          isAdmin={isAdmin}
        />

        <IconButton id="profile-button" className={isLoggedIn ? "" : "hidden"} onClick={handleOpenMenu} sx={{ p: 0, marginLeft: 'auto' }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              <KeyboardArrowDownIcon
                sx={{
                  bgcolor: 'white',
                  borderRadius: '50%',
                  fontSize: '1rem',
                  border: '1px solid #ccc',
                  color: 'black'
                }}
              />
            }
          >
            <Avatar
              className={isLoggedIn ? "" : "hidden"}
              src={localStorage.getItem('profilePicture') || ""}
              alt="ProfilePicture"
              sx={{
                width: { xs: '50px', sm: '60px' },
                height: { xs: '50px', sm: '60px' },
              }}
            />
          </Badge>
        </IconButton>

        {/* 2. The Actual Menu: This stays hidden until anchorEl is set */}
        <HeaderProfileSettings
          anchorEl={anchorEl}
          handleCloseMenu={handleCloseMenu}
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          handleOpenMenu={handleOpenMenu}
          isAdmin={isAdmin}
        />
      </Toolbar>
    </AppBar>


  );
};

export default HeaderBar;

